import monster1 from "@/assets/avatars/monster1.png";
import monster2 from "@/assets/avatars/monster2.png";
import monster3 from "@/assets/avatars/monster3.png";
import monster4 from "@/assets/avatars/monster4.png";
import monster5 from "@/assets/avatars/monster5.png";
import monster6 from "@/assets/avatars/monster6.png";
import monster7 from "@/assets/avatars/monster7.png";
import monster8 from "@/assets/avatars/monster8.png";

const AVATAR_MAP: Record<string, string> = {
  "/src/assets/avatars/monster1.png": monster1,
  "/src/assets/avatars/monster2.png": monster2,
  "/src/assets/avatars/monster3.png": monster3,
  "/src/assets/avatars/monster4.png": monster4,
  "/src/assets/avatars/monster5.png": monster5,
  "/src/assets/avatars/monster6.png": monster6,
  "/src/assets/avatars/monster7.png": monster7,
  "/src/assets/avatars/monster8.png": monster8,
};

export const resolveAvatarUrl = (url?: string | null): string | undefined => {
  if (!url) return undefined;
  const base = url.split("?")[0];
  return AVATAR_MAP[base] || url;
};
